import { Stack } from '@fluentui/react';
import React, { useEffect } from 'react';

// assets

import { useStore } from '../../../stores/root';
import { faHome } from '@fortawesome/pro-light-svg-icons';
import EmployeeContractsList from '../../../components/hr/contracts/general/list';
import PermissionsService from '../../../services/permissions';
import NoAccess from '../../../components/uiframeworks/noAccess';

interface HRDashboardPageProps {
}

const EmployeeContractsListPage: React.FC<HRDashboardPageProps> = (props: HRDashboardPageProps) => {
    const {user, topbar} = useStore();
    const hasPermission = PermissionsService.hasPermission(['employees.payslips.read.all'], user.permissions);
    
    useEffect(() => {
        topbar.show('Employee Contracts', [
            {key: 'home', icon: faHome},
            {key: 'employees', text: 'Employees'},
            {key: 'contracts', text: 'Contracts'}
        ]);
    }, []);

    return <Stack>
        {hasPermission ? <EmployeeContractsList /> : null}
        {!hasPermission ? <NoAccess /> : null}
    </Stack>;
};

export default EmployeeContractsListPage;
